var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHamburgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2223 20.1389H2.77782C2.59364 20.1389 2.41701 20.0657 2.28677 19.9355C2.15654 19.8053 2.08337 19.6286 2.08337 19.4444C2.08337 19.2603 2.15654 19.0836 2.28677 18.9534C2.41701 18.8232 2.59364 18.75 2.77782 18.75H22.2223C22.4064 18.75 22.5831 18.8232 22.7133 18.9534C22.8435 19.0836 22.9167 19.2603 22.9167 19.4444C22.9167 19.6286 22.8435 19.8053 22.7133 19.9355C22.5831 20.0657 22.4064 20.1389 22.2223 20.1389Z",
    fill: "#3E3E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2223 13.1944H2.77782C2.59364 13.1944 2.41701 13.1213 2.28677 12.991C2.15654 12.8608 2.08337 12.6842 2.08337 12.5C2.08337 12.3158 2.15654 12.1392 2.28677 12.0089C2.41701 11.8787 2.59364 11.8055 2.77782 11.8055H22.2223C22.4064 11.8055 22.5831 11.8787 22.7133 12.0089C22.8435 12.1392 22.9167 12.3158 22.9167 12.5C22.9167 12.6842 22.8435 12.8608 22.7133 12.991C22.5831 13.1213 22.4064 13.1944 22.2223 13.1944Z",
    fill: "#3E3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2223 6.24997H2.77782C2.59364 6.24997 2.41701 6.17681 2.28677 6.04657C2.15654 5.91634 2.08337 5.73971 2.08337 5.55553C2.08337 5.37135 2.15654 5.19472 2.28677 5.06448C2.41701 4.93425 2.59364 4.86108 2.77782 4.86108H22.2223C22.4064 4.86108 22.5831 4.93425 22.7133 5.06448C22.8435 5.19472 22.9167 5.37135 22.9167 5.55553C22.9167 5.73971 22.8435 5.91634 22.7133 6.04657C22.5831 6.17681 22.4064 6.24997 22.2223 6.24997Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHamburgDefault);
export default __webpack_public_path__ + "static/media/ic-hamburg-default.4c22dce4d5ff239ad3f12363e46b8c7e.svg";
export { ForwardRef as ReactComponent };